"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeGroceryCategoryMutationOptions = exports.changeGroceryCategoryMutation = void 0;
const client_1 = require("@apollo/client");
const groceryItems_1 = require("../queries/groceryItems");
exports.changeGroceryCategoryMutation = client_1.gql `
  mutation changeGroceryCategory(
    $id: String!
    $keyword: String!
    $groceryCategoryName: String!
  ) {
    changeGroceryCategory(
      id: $id
      groceryCategoryName: $groceryCategoryName
      keyword: $keyword
    ) {
      id
      groceryCategoryName
    }
  }
`;
exports.changeGroceryCategoryMutationOptions = (variables) => ({
    variables,
    update: !variables.keyword
        ? undefined
        : store => {
            let data = null;
            try {
                data = store.readQuery({
                    query: groceryItems_1.groceryItemsQuery,
                });
            }
            catch (err) {
                return;
            }
            if (data) {
                store.writeQuery({
                    query: groceryItems_1.groceryItemsQuery,
                    data: {
                        __typename: "Query",
                        groceryItems: {
                            __typename: "GroceryItemsResponse",
                            items: data.groceryItems.items.map(gi => gi.keyword === variables.keyword
                                ? Object.assign(Object.assign({}, gi), { groceryCategoryName: variables.groceryCategoryName }) : gi),
                            recipes: data.groceryItems.recipes,
                        },
                    },
                });
            }
        },
});
//# sourceMappingURL=changeGroceryCategory.js.map